<ngx-spinner></ngx-spinner>
<section>
  <div class="row" *ngIf="showAlertMessage">
      <div class="col-md-1"></div>
      <div class="col-md-10">
          <div class="card p-p-2"
              style="border-left-color: red;border-left-style: solid;border-left-width: 5px;border-right-color: red;border-right-style: solid; border-right-width: 5px;">
              <span class="text-nomal text-danger p-text-center">{{alertMessage}}</span>
             
          </div>
         
      </div>
      <div class="col-md-1"></div>
  </div>
</section>

<section>
  <!-- <div class="p-p-5 p-mb-6" style="margin-left: -16px;margin-top: -5px;margin-right: -16px;background-color: #f4fafe;">
    <div class="row row-cards">
     
      <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #0cbaba;">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span><i class="pi pi-briefcase" style="font-size: 2rem;color: white;"></i></span>
                </span>
              </div>
              <div class="col">
                <div class="font-weight-medium">
                  <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Requisitions</span>
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-auto">
                <span class="text-white">
                  <span class=" align-items-left">Open</span>
                </span>
              </div>
              <div class="col">
                <span class="text-white">
                  <span class=" align-items-left">Active</span>
                </span>
              </div>
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class=" align-items-right">Total Submissions</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <p-badge [value]="dashboardCount.requisitionOpenTotal"  styleClass="mr-2 bg-badge-box2-left"></p-badge>
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.requisitionActiveTotal"  styleClass="mr-2 bg-badge-box2-left"></p-badge>
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.submittedApplicants" styleClass="mr-2 float-right bg-badge-box2-right"></p-badge>              
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #7f5a83;">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span><i class="pi pi-user-edit" style="font-size: 2rem;color: white;"></i></span>
                </span>
              </div>
              <div class="col">
                <div class="font-weight-medium">
              <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Interviews</span>                
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-auto">
                <span class="text-white">
                  <span class=" align-items-left">Scheduled</span>
                </span>
              </div>
              <div class="col">
                <div class="font-weight-bold text-white avatar align-items-center" style="margin-left: 33px !important;">
                  <span class=" align-items-left">Re-scheduled</span>
                </div>
              </div>
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class=" align-items-right">Accepted</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <p-badge [value]="dashboardCount.scheduledInterviews"  styleClass="mr-2 bg-badge-box3-left"></p-badge>
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.reScheduledInterviews"  styleClass="mr-2 bg-badge-box3-middle"></p-badge>              
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.acceptedInterviews"  styleClass="mr-2 float-right bg-badge-box3-right"></p-badge>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #2a2a72;">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class="text-left"><i class="fas fa-handshake" style="font-size: 2rem;color: white;"></i></span>
                </span>              
              </div>
              <div class="col">
                <div class="font-weight-medium">
              <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Engagements</span>
                  
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-auto">
                <span class="text-white">
                  <span class=" align-items-left">Initiated</span>
                </span>
              </div>
              <div class="col">
                <span class="text-white avatar">
                  <span class=" align-items-right">Negotiated</span>
                </span>
              </div>
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class=" align-items-right">Accepted</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <p-badge [value]="dashboardCount.offerInitiated"  styleClass="mr-2 bg-badge-box4-left"></p-badge>
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.offerNegotiated"  styleClass="mr-2 bg-badge-box4-middle"></p-badge>              
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.offerAccepted"  styleClass="mr-2 float-right bg-badge-box4-right"></p-badge>              
              </div>
            </div>
          </div>
        </div>
      </div> 
      <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #2a2a72;">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class="text-left"><i class="fas fa-handshake" style="font-size: 2rem;color: white;"></i></span>
                </span>              
              </div>
              <div class="col">
                <div class="font-weight-medium">
              <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Invoices</span>
                  
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-auto">
                <span class="text-white">
                  <span class=" align-items-left">Approved</span>
                </span>
              </div>
              <div class="col">
                <span class="text-white avatar">
                  <span class=" align-items-right">Rejected</span>
                </span>
              </div>
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class=" align-items-right">Payment on-Hold</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoiceApproved"  styleClass="mr-2 bg-badge-box4-left"></p-badge>
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoiceRejected"  styleClass="mr-2 bg-badge-box4-middle"></p-badge>              
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoicePaymentonHold"  styleClass="mr-2 float-right bg-badge-box4-right"></p-badge>              
              </div>
            </div>
          </div>
        </div>
      </div> 
    
    </div>
    
  </div> -->

  <div class="p-p-5 p-mb-3" style="margin-left: -16px;margin-top: -5px;margin-right: -16px;background-color: #2884b8;background-image: linear-gradient(315deg, #2884b8 0%, #6b376d 74%);">
    <div class="row row-cards">
      <!-- <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #2884b8;background-image: linear-gradient(315deg, #2884b8 0%, #d1bad2 74%);">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span><i class="fas fa-user" style="font-size: 2rem;color: white;"></i></span>
                </span>
              </div>
              <div class="col">
                <div class="font-weight-medium">
                  <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue; font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Applicants</span>
                </div>
                <!- <div class="text-muted"> </div> ->
              </div>
            </div> <hr>       
            <div class="row">
              <div class="col-6">
                <span class="text-white">
                  <span class=" align-items-left">Available</span>
                </span>
              </div>
              <!- <div class="col">
                <div class="font-weight-bold text-white avatar align-items-center" style="margin-left: 33px !important;">
                  <!-<span style="font-size: x-large;">{{dashboardCount.applicantsTotal}}</span>->
                </div>
              </div>->
              <div class="col-6">
                <span class="text-white avatar">
                  <span class=" align-items-right">Not-Available</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p-badge [value]="dashboardCount.applicantsAvailable"   styleClass=""></p-badge>
              </div>
              <div class="col-6">
                <p-badge [value]="dashboardCount.applicantsNotAvailable"  styleClass=""></p-badge>              
              </div>
            </div>
          </div>
        </div>
      </div> -->
  
      <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #7f5a83;background-image: linear-gradient(315deg, #7f5a83 0%, #0d324d 74%);">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span><i class="fas fa-briefcase" style="font-size: 2rem;color: white;"></i></span>
                </span>
              </div>
              <div class="col">
                <div class="font-weight-medium">
              <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Requisitions</span>                
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-3">
                <span class="text-white">
                  <span class="align-items-left">Open</span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white">
                  <span class=" align-items-center">Active</span>
                </span>
              </div>
              <div class="col-5">
                <span class="text-white avatar">
                  <span class=" align-items-right">Submissions</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <span class="text-white">
                  <span class=" align-items-left">  <p-badge [value]="dashboardCount.requisitionOpenTotal"  styleClass=""></p-badge></span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white">
                  <span class=" align-items-center"> <p-badge [value]="dashboardCount.requisitionActiveTotal"  styleClass=""></p-badge></span>
                </span>
              </div>
              <div class="col-5">
                <span class="text-white avatar">
                  <span class=" align-items-right"><p-badge [value]="dashboardCount.submittedApplicants" styleClass=""></p-badge></span>
                </span>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    
      <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #7f5a83;background-image: linear-gradient(315deg, #7f5a83 0%, #0d324d 74%);">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span><i class="fas fa-user-edit" style="font-size: 2rem;color: white;"></i></span>
                </span>
              </div>
              <div class="col">
                <div class="font-weight-medium">
              <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Interviews</span>                
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-auto">
                <span class="text-white">
                  <span class=" align-items-left">Scheduled</span>
                </span>
              </div>
              <div class="col-auto">
                <span class="text-white">
                  <span class=" align-items-center" >Rescheduled</span>
                </span>
              </div>
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class=" align-items-right">Accepted</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <span class="text-white">
                  <span class=" align-items-left">  <p-badge [value]="dashboardCount.scheduledInterviews"  styleClass=""></p-badge></span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white">
                  <span class=" align-items-left"> <p-badge [value]="dashboardCount.reScheduledInterviews"  styleClass=""></p-badge></span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white avatar">
                  <span class=" align-items-right"><p-badge [value]="dashboardCount.acceptedInterviews" styleClass=""></p-badge></span>
                </span>
              </div>
            </div>
  
          </div>
        </div>
      </div>
  
      <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #2a2a72;background-image: linear-gradient(315deg, #2a2a72 0%, #009ffd 74%);">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class="text-left"><i class="fas fa-handshake" style="font-size: 2rem;color: white;"></i></span>
                </span>              
              </div>
              <div class="col">
                <div class="font-weight-medium">
              <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Engagements</span>
                  
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-4">
                <span class="text-white">
                  <span class=" align-items-left">Initiated</span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white avatar">
                  <span class=" align-items-center">Negotiated</span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white avatar">
                  <span class=" align-items-right">Accepted</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <p-badge [value]="dashboardCount.offerInitiated" ></p-badge>
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.offerNegotiated"></p-badge>              
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.offerAccepted"></p-badge>              
              </div>
            </div>
          </div>
        </div>
      </div>
       
      <div class="col-sm-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #2a2a72;background-image: linear-gradient(315deg, #2a2a72 0%, #009ffd 74%);">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class="text-left"><i class="fas fa-file-invoice-dollar" style="font-size: 2rem;color: white;"></i></span>
                </span>              
              </div>
              <div class="col">
                <div class="font-weight-medium">
              <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Invoices</span>
                  
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-4">
                <span class="text-white">
                  <span class=" align-items-left">Approved</span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white avatar">
                  <span class=" align-items-center">Rejected</span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white avatar">
                  <span class=" align-items-right">On-Hold</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoiceApproved" ></p-badge>
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoiceRejected"></p-badge>              
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoicePaymentonHold"></p-badge>              
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- <div class="row row-cards">
      <div class="col-lg-3">
  
      </div>
      <div class="col-lg-6 col-lg-3">
        <div class="card card-sm" style="border-radius:8px;background-color: #30999c;background-image: linear-gradient(315deg, #2a2a72 0%, #5394b9 74%);">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-auto">
                <span class="text-white avatar">
                  <span class="text-left"><i class="fas fa-file-invoice-dollar" style="font-size: 2rem;color: white;"></i></span>
                </span>              
              </div>
              <div class="col">
                <div class="font-weight-medium">
              <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px rgb(32, 86, 138);font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" >Invoices</span>
                  
                </div>
              </div>
            </div><hr>
            <div class="row">
              <div class="col-4">
                <span class="text-white">
                  <span class=" align-items-left">Approved</span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white avatar">
                  <span class=" align-items-center">Rejected</span>
                </span>
              </div>
              <div class="col-4">
                <span class="text-white avatar">
                  <span class="align-items-left">Payment On-Hold</span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoiceApproved" ></p-badge>
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoiceRejected"></p-badge>              
              </div>
              <div class="col-4">
                <p-badge [value]="dashboardCount.invoicePaymentonHold"></p-badge>              
              </div>
            </div>
          </div>
        </div>
      </div>  
      <div class="col-lg-3">
        
      </div>
    </div> -->
    <br>
  </div>

  <div class="col-lg-12">
    <div class="card">
      <div class="row devcare-card-body">
<div class="col-lg-2">
  <button [ngClass]="enableFilter === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
  pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
  style="float: left;height: 30px;"></button>
</div>
<div class="col-lg-8"></div>
<div class="col-lg-2">
  <button pButton pRipple type="button" label="Clear" icon="pi pi-filter-slash" 
  class="p-button-sm p-button-raised p-button m-2" style="float: right; height: 30px;" (click)="clearFilter()"></button>
</div>
    </div> 
      </div>
    <p-tabView>
     <p-tabPanel header="Due">
         <p>
           <p-table [value]="companyCOIChangeRequestDueList" styleClass="p-datatable" [tableStyle]="{ 'min-width': '50rem' }">
              <ng-template pTemplate="header">
                 <tr>
                  <th style="width: 20rem">
                    <div *ngIf="enableFilter">
                    <form [formGroup]="dueFilterForm" novalidate>
                    <div class="row p-field p-col-12">
                      <div class="p-md-2" >  </div>
                    <div class=" p-md-4" >
                      <p-dropdown  optionValue="value" formControlName="filterType" (onChange)="getFilterTypeOnChange($event)" [options]="filterItem" optionLabel="header" placeholder="Select a filter criteria">
                    </p-dropdown>
                </div>
                <div class=" p-md-4" *ngIf="!documentTypeEnable">
                  <input type="text" class="form-control" maxlength="100" placeholder="Enter filter value" formControlName="filterValue"
                    pInputText>
                </div>
                <div class="p-md-4" *ngIf="documentTypeEnable">
                  <p-dropdown #dropdown formControlName="documentType"
                                                (onChange)="getDocumentTypeOnChange($event)"
                                                [options]="documentTypes"
                                                placeholder="Select" 
                                                optionLabel="description">
                                            </p-dropdown>
                </div>
                <div class="p-md-2" style="text-align: center;">
                  <button pButton pRipple type="button" label="Search" icon="pi pi-search" [disabled]="!dueFilterForm.valid"
                  class="p-button-sm p-button-raised p-button m-2" (click)="search(dueFilterForm)"></button>
                  
                 </div>

              </div>
                </form>
              </div>
            </th>
                  <th style="width: 4rem">
                    <!-- <button [ngClass]="enableFilter === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                      pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                      [loading]="isSearchLoading" style="float: left;height: 30px;"></button> -->
                  </th>
                  </tr>
              </ng-template>
             <ng-template pTemplate="body" let-changeRequest>
                 <tr>
        <td><span *ngIf="changeRequest.documentTypeId==5" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">Updated their COI and the insurance dates</a></span>
          <span *ngIf="changeRequest.documentTypeId==3" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">Updated their DD Authorization</a></span>
          <span *ngIf="changeRequest.documentTypeId==4" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">Updated their Void Cheque</a></span>
          <span *ngIf="changeRequest.documentTypeId==6" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">Updated their W9</a></span>
          <span *ngIf="changeRequest.documentTypeId==7" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">Updated their I9</a></span>
          <span *ngIf="changeRequest.documentTypeId==8" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">Updated their E-Verification</a></span>
          <span *ngIf="changeRequest.documentTypeId==2" class="table-col-view">{{changeRequest.comments}} - {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">has updated their NCA</a></span>
          <span *ngIf="changeRequest.documentTypeId==1" class="table-col-view">{{changeRequest.comments}} - {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">MSA</a></span>
          <span *ngIf="changeRequest.documentTypeId==9" class="table-col-view">{{changeRequest.comments}} - {{changeRequest.companyName}} - <a [routerLink]="" (click)="getSelectedChangeRequestDetails(changeRequest.comments,changeRequest.documentId,changeRequest.companyName)">PO</a></span>
          <br/>
                     <span *ngIf="changeRequest.documentTypeId==5" class="customer-badge status-invoice-withdrawn">COI</span>
                     <span *ngIf="changeRequest.documentTypeId==3" class="customer-badge status-invoice-withdrawn">DD Authorization</span>
                     <span *ngIf="changeRequest.documentTypeId==4" class="customer-badge status-invoice-withdrawn">Void Cheque/Bank Letter</span>
                     <span *ngIf="changeRequest.documentTypeId==6" class="customer-badge status-invoice-withdrawn">W9</span>
                     <span *ngIf="changeRequest.documentTypeId==7" class="customer-badge status-invoice-withdrawn">I9</span>
                     <span *ngIf="changeRequest.documentTypeId==8" class="customer-badge status-invoice-withdrawn">E-Verification</span>
                     <span *ngIf="changeRequest.documentTypeId==2" class="customer-badge status-invoice-withdrawn">NCA Approval Request</span>
                     <span *ngIf="changeRequest.documentTypeId==1" class="customer-badge status-invoice-withdrawn">MSA</span>
                     <span *ngIf="changeRequest.documentTypeId==9" class="customer-badge status-invoice-withdrawn">PO</span>
                    </td>
          <td><span style="border-radius: 5px;padding: 5px;background: aliceblue;">{{changeRequest.modifiedOn | date:'MMM dd, yyyy'}}</span></td>
                 </tr>
             </ng-template>
         </p-table>
         </p>
     </p-tabPanel>
     <p-tabPanel header="Archive">
       <p-table [value]="companyCOIChangeRequestArchiveList"  styleClass="p-datatable" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
              <tr>
                 <th style="width: 20rem">
                  <div *ngIf="enableFilter">
                  <form [formGroup]="archiveFilterForm" novalidate>
                    <div class="row p-field p-col-12">
                      <div class="p-md-2" >  </div>
                    <div class=" p-md-4" >
                      <p-dropdown  optionValue="value" formControlName="filterType" (onChange)="getArchiveFilterTypeOnChange($event)" [options]="filterItem" optionLabel="header" placeholder="Select a filter criteria">
                    </p-dropdown>
                </div>
                <div class=" p-md-4" *ngIf="!archiveDocumentTypeEnable">
                  <input type="text" class="form-control" maxlength="100" placeholder="Enter filter value" formControlName="filterValue"
                    pInputText>
                </div>
                <div class="p-md-4" *ngIf="archiveDocumentTypeEnable">
                  <p-dropdown #dropdown formControlName="documentType"
                                                (onChange)="getArchiveDocumentTypeOnChange($event)"
                                                [options]="documentTypes"
                                                placeholder="Select" 
                                                optionLabel="description">
                                            </p-dropdown>
                </div>
                <div class="p-md-2" style="text-align: center;">
                  <button pButton pRipple type="button" label="Search" icon="pi pi-search" [disabled]="!archiveFilterForm.valid"
                  class="p-button-sm p-button-raised p-button m-2" (click)="archiveSearch(archiveFilterForm)"></button>
                 </div>

              </div>
                </form>
              </div>
                </th>
                  <th style="width: 4rem"></th>
             </tr>

          </ng-template>
         <ng-template pTemplate="body" let-changeRequest>
             <tr>
                <td>
                  <!-- <span class="table-col-view">{{changeRequest.companyName}}</span> -->
                   <span *ngIf="(changeRequest.statusId===2)">
                  <span *ngIf="changeRequest.documentTypeId==5" class="table-col-view"> {{changeRequest.companyName}} - Updated their COI and the insurance dates</span>
<span *ngIf="changeRequest.documentTypeId==3" class="table-col-view"> {{changeRequest.companyName}} - Updated their DD Authorization</span>
<span *ngIf="changeRequest.documentTypeId==4" class="table-col-view"> {{changeRequest.companyName}} - Updated their Void Cheque</span>
<span *ngIf="changeRequest.documentTypeId==6" class="table-col-view"> {{changeRequest.companyName}} - Updated their W9</span>
<span *ngIf="changeRequest.documentTypeId==7" class="table-col-view"> {{changeRequest.companyName}} - Updated their I9</span>
<span *ngIf="changeRequest.documentTypeId==8" class="table-col-view"> {{changeRequest.companyName}} - Updated their E-Verification</span>
<span *ngIf="changeRequest.documentTypeId==2" class="table-col-view"> {{changeRequest.comments}} - {{changeRequest.companyName}} - has updated their NCA</span>
<span *ngIf="changeRequest.documentTypeId==1" class="table-col-view"> {{changeRequest.comments}} - {{changeRequest.companyName}} - has updated their MSA</span>
<span *ngIf="changeRequest.documentTypeId==9" class="table-col-view"> {{changeRequest.comments}} - {{changeRequest.companyName}} - has updated their PO</span>
</span>
<span *ngIf="(changeRequest.statusId===3)">
  <span *ngIf="changeRequest.documentTypeId==5" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their COI and the insurance dates</a></span>
  <span *ngIf="changeRequest.documentTypeId==3" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their DD Authorization</a></span>
  <span *ngIf="changeRequest.documentTypeId==4" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their Void Cheque</a></span>
  <span *ngIf="changeRequest.documentTypeId==6" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their W9</a></span>
  <span *ngIf="changeRequest.documentTypeId==7" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their I9</a></span>
  <span *ngIf="changeRequest.documentTypeId==8" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their E-Verification</a></span>
  <span *ngIf="changeRequest.documentTypeId==1" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their MSA</a></span>
  <span *ngIf="changeRequest.documentTypeId==2" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their NCA</a></span>
  <span *ngIf="changeRequest.documentTypeId==9" class="table-col-view"> {{changeRequest.companyName}} - <a [routerLink]="" (click)="getReApproveRequestDetails(changeRequest.documentId,changeRequest.companyName)">Updated their PO</a></span>
</span>
        <br/>
             <span class="customer-badge status-invoice-approved"
                 *ngIf="(changeRequest.statusId===2)">Approved</span>
             <span class="customer-badge status-invoice-rejected"
                 *ngIf="(changeRequest.statusId===3)">Rejected</span></td>
   <td><span style="border-radius: 5px;padding: 5px;background: aliceblue;">{{changeRequest.modifiedOn | date:'MMM dd, yyyy'}}</span></td>
             </tr>
         </ng-template>
     </p-table>
     </p-tabPanel>
     <p-tabPanel header="Onboards/Vendor Documents">
      <p>

        <p-table [value]="OnboardProcessApprovalPendingAlertsRequest" styleClass="p-datatable" [tableStyle]="{ 'min-width': '50rem' }">
           <ng-template pTemplate="header">
              <tr>
               <th style="width: 20rem"></th>
               <th style="width: 4rem"></th>
               </tr>

           </ng-template>
          <ng-template pTemplate="body" let-changeRequest>
              <tr>
     <td><span class="table-col-view"> {{changeRequest.vendorName}} - <a [routerLink]="" (click)="viewVendorInfo(changeRequest.tempVendorId)">Vendor onboarding</a></span>
       
       <br/>
                  <span class="customer-badge status-invoice-withdrawn" *ngIf="!changeRequest.isVendorAvailable">Onboard Approval Request</span>
                  <span class="customer-badge status-invoice-withdrawn"  *ngIf="changeRequest.isVendorAvailable">Document Approval Request</span>
                  
                 </td>
       <td><span style="border-radius: 5px;padding: 5px;background: aliceblue;">{{changeRequest.modifiedOn | date:'MMM dd, yyyy'}}</span></td>
              </tr>
          </ng-template>
      </p-table>
      </p>
  </p-tabPanel>  
 </p-tabView>
 </div>
 <p-toast position="bottom-center"></p-toast>
  </section>
<br>
<br>

<!-- <div class="container">
<div class="row">
  <div class="col-2"></div>
  <div class="col-8">
    <div class="p-d-flex p-jc-between">
      <div>
        <img src="../../../../assets/img/dashboard.png" class="text-right" width="200px" alt="">
      </div>
      <div>
        <div class="card-header">
          <span><h2  style="font-weight: 700;">Dashboard coming soon!</h2></span>
        </div>
        <div class="card-footer">
          <span class="text-lg">We are currently building a dashboard,</span><br>
          <span class="text-lg">where you can view all your analytics</span><br>
          <span class="text-lg">and reports in one page.</span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-2"></div>
</div>
</div> -->
<!-- COI Details Update Popup-->
<p-dialog id="updateCOI" [showHeader]="false" [(visible)]="COIChangeRequestDetailsDialog" [modal]="true" style="height:10px!important;"
[style]="{height:'auto'}" [draggable]="true" [resizable]="false" [closable]="false">
  <div class="p-dialog-header">
      <span class="p-dialog-title">COI Change Request Details</span>
      <div class="p-dialog-header-icons">
        <button type="button" class="p-dialog-header-icon p-dialog-header-maximize p-link"
          (click)="COIChangeRequestDetailsDialog=false;closeCOIRequestDialog()"><span
            class="p-dialog-header-close-icon pi pi-times"></span></button>
      </div>
    </div>

  <div style="padding: 0px 20px 20px 20px;">
      
    <form [formGroup]="companyCOIDetailsUpdateForm">
      <div  class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label> General Liability Eff Date <span class="required-field">*</span></label>
            <p-calendar #generalLiablityEffDate  [showIcon]="true" type="date" formControlName="glEffDate"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>General Liability Exp Date<span class="required-field">*</span></label>
            <p-calendar #generalLiablityExpDate  [showIcon]="true" type="date" formControlName="glExpDate"   [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label> Automobile Liability Eff Date<span class="required-field">*</span> </label>
            <p-calendar  #automobileLiabilityEffDate  [showIcon]="true" type="date" formControlName="alEffDate"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>Automobile Liability Exp Date<span class="required-field">*</span></label>
            <p-calendar #automobileLiablityExpDate  id="calendar-id" [showIcon]="true" type="date" formControlName="alExpDate"   [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
        </div>
        <div  class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label> Umbrella Liability Eff Date<span class="required-field">*</span></label>
            <p-calendar  #umbrellaLiablityEffDate [showIcon]="true" type="date" formControlName="ulEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>Umbrella Liability Exp Date<span class="required-field">*</span></label>
            <p-calendar #umbrellaLiabilityExpDate [showIcon]="true" type="date" formControlName="ulExpDate"   [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label> Workers Compensation Eff Date<span class="required-field">*</span></label>
            <p-calendar #workersCompensationEffDate [showIcon]="true" type="date"  formControlName="wcEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>Workers Compensation Exp Date<span class="required-field">*</span></label>
            <p-calendar  #workersCompensationExpDate  [showIcon]="true" id="calendar-id"  type="date" formControlName="wcExpDate"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label> Professional Liabilty Eff Date<span class="required-field">*</span></label>
            <p-calendar #professtionalLiabilityEffDate  [showIcon]="true" type="date"  formControlName="plEffDate"[monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>Professional Liabilty Exp Date<span class="required-field">*</span></label>
            <p-calendar #PrefessionalLiabilityExpDate [showIcon]="true" type="date"   formControlName="plExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <div class="p-d-flex p-jc-between">
              <div class="p-text-bold">COI</div> 
              <div>
                  <button  *ngIf="showCOIFormFilePreviewEnableOnRequest" pButton pRipple type="button" [style]="{width:'70px',height:'30px'}" (click)="ShowInsuranceUploadedFileOnRequest()" label="View"  class="p-button-sm p-button-raised" style="margin-top: -3px;"></button>                                                
              </div>
          </div>       
            
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
             <label>Comments</label>
              <textarea formControlName="comments" maxlength="1000" pInputTextarea
              class="form-control" disabled></textarea>
          </div>
        </div>
        <br><br>
      </form>
       <br><br>
           <div class="text-right" style="margin-top:-40px;">
            <p-button icon="pi pi-times" label="Reject"
            (onClick)="COIChangeRequestDetailsDialog=true;rejectionNotesDilaog=true;"
            [style]="{height:'30px','margin-right':'10px'}"  styleClass=" p-button-danger p-button-text"></p-button>
               <p-button icon="pi pi-check" label="Approve" [disabled]="!this.companyCOIDetailsUpdateForm.valid"
                   (onClick)="updateCompanyCOIDetails(companyCOIDetailsUpdateForm)" [style]="{height:'30px'}" styleClass="p-button-text p-button-success p-mr-2"
                   [style]="{height:'30px'}"></p-button>
           </div>
           <br><br>
     </div>
</p-dialog>
<p-dialog header="{{Header}}" [(visible)]="documnetChangeRequestDetailsDialog" [modal]="true" [style]="{width: '50vw'}"
                    [draggable]="false" [resizable]="false"  [closable]="true">
                    
                    <div class=" p-mt-2 p-mb-2">
                    </div>
                    <div class="col-md-12">
                      <div class="card">
                        <div class="card-header">
                    <label>{{documentName}}</label>
                    <!-- <button pButton pRipple type="button" icon="pi pi-eye"  (click)="ShowInsuranceUploadedFileOnRequest()" [disabled]="!showCOIFormFilePreviewEnableOnRequest"
                      class="p-button-raised" style="float: right;border-radius: 50%;height: 30px;"></button> -->
                    </div>
                    <div class="card-body" style="height: 70px; display: flex; justify-content: center; align-items: center;">
                      <button pButton pRipple type="button" label="Preview" (click)="ShowInsuranceUploadedFileOnRequest()" [disabled]="!showCOIFormFilePreviewEnableOnRequest"
                      class="p-button-raised" [style]="{width:'100px',height:'30px'}"></button>
                      </div>
                      <div class="card-footer"></div>
                </div>
                    </div>
                    <br><br>
                    <div class="text-right" style="margin-top:-40px;">
                      <p-button icon="pi pi-times" label="Reject"  *ngIf="documentName!='NCA'"
                      (onClick)="documnetChangeRequestDetailsDialog=true;rejectionNotesDilaog=true;"
                      [style]="{height:'30px','margin-right':'10px'}"  styleClass=" p-button-danger p-button-text"></p-button>
                         <p-button icon="pi pi-check" label="Approve" *ngIf="!isApproveComments && documentName!='NCA'"
                             (onClick)="updateCompanyDocumentDetails(companyCOIDetailsUpdateForm)" [style]="{height:'30px'}" styleClass="p-button-text p-button-success p-mr-2"
                             [style]="{height:'30px'}"></p-button>
                             <p-button icon="pi pi-check" label="Approve" *ngIf="isApproveComments"
                             (onClick)="documnetChangeRequestDetailsDialog=true;approveNotesDilaog=true;" [style]="{height:'30px'}" styleClass="p-button-text p-button-success p-mr-2"
                             [style]="{height:'30px'}"></p-button>
                             <p-button icon="pi pi-check" label="Approve NCA" *ngIf="!isApproveComments && documentName=='NCA'"
                             (onClick)="updateCompanyDocumentDetails(companyCOIDetailsUpdateForm)" [style]="{height:'30px'}" styleClass="p-button-text p-button-success p-mr-2"
                             [style]="{height:'30px'}"></p-button>
                     </div>
                     
  </p-dialog>

<p-dialog  [(visible)]="rejectionNotesDilaog" [modal]="true" [style]="{width: '50vw'}"
                    [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false">
                    <div class="p-dialog-header">
                      <span class="p-dialog-title">Rejection</span>
                      <div class="p-dialog-header-icons">
                        <button type="button" class="p-dialog-header-icon p-dialog-header-maximize p-link"
                          (click)="rejectionNotesDilaog=false;cancelNotes();"><span
                            class="p-dialog-header-close-icon pi pi-times"></span></button>
                      </div>
                    </div>
                    <div class=" p-mt-2 p-mb-2">
                        <span>Note:</span>
                        <ul> 
                            <li>Image size should be less than 2MB</li>
                            <li>Only JPG or PNG files are allowed</li>
                        </ul>
                    </div>
                    <div class="col-md-12">
                        <!-- <p-editor [formControl]="notesFormControl"
                        [style]="{'height':'100px'}" required></p-editor> -->
                        <quill-editor [modules]="editorModules" [formControl]="notesFormControl" placeholder="" required></quill-editor>
                        <span class="text-danger" *ngIf="notesFormControl?.hasError('maxlengthError')">
                            Only 500 characters allowed.
                          </span>
                    </div>
                        <p-button icon="pi pi-check" [disabled]= "!notesFormControl.valid || isUploadCompleted" (onClick)="rejectionNotesDilaog=false;COIChangeRequestDetailsDialog=false;documnetChangeRequestDetailsDialog=false;rejectCompanyCOIDetails(companyCOIDetailsUpdateForm)" label="Submit"
                            styleClass="p-button-text"></p-button>
                        <p-button icon="pi pi-times" (click)="rejectionNotesDilaog=false;cancelNotes();"
                            label="Cancel" styleClass="p-button-text"></p-button>
  </p-dialog>
  <p-dialog header="Document Approval" [(visible)]="approveNotesDilaog" [modal]="true" 
[draggable]="false" [resizable]="false" [closable]="false" style="width: 60% !important;">
    <div class="p-field p-col-12 p-md-1">                                
    </div>
    <div class="card p-m-2 p-p-2">
        <div class="p-text-bold">Comments</div>
        <quill-editor [modules]="approvePopUpModel" [formControl]="commentsFormControl" placeholder=""
                ></quill-editor>
            <span class="text-danger"  *ngIf="commentsFormControl?.hasError('maxlengthError')">
                Only 500 characters allowed.
            </span>
    </div>
    <div class="p-d-flex p-jc-end p-ai-right p-mt-2">
        <p-button  icon="pi pi-times" [ngStyle]="{'height.px': 30 }" styleClass=" p-button-danger p-mr-2"  (onClick)="cancelApproval()" pRipple type="button"
            label="Cancel" class="p-button-sm p-button-info p-ai-center"></p-button>&nbsp;&nbsp;&nbsp;
        <p-button icon="pi pi-check" [ngStyle]="{'height.px': 30 }" styleClass=" p-button-success p-mr-2" 
            (onClick)="updateDDCompanyDocumentDetails(companyCOIDetailsUpdateForm)" pRipple type="button" label="Submit"
            class="p-button-sm p-button-info p-ai-center"></p-button>
    </div>
</p-dialog>
  <p-confirmDialog key ="COIUpdateConfirm" header="Confirmation" [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #coiconfirm>
    <ng-template pTemplate="footer">
      <button type="button" pButton icon="pi pi-check" label="Yes" (click)="coiconfirm.accept()"></button>
      <button type="button" pButton icon="pi pi-times" label="No" (click)="coiconfirm.reject()"></button>
  </ng-template>
  </p-confirmDialog>

  <p-confirmDialog key ="ReApproveUpdateConfirm" header="Confirmation" [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #ReApproveconfirm>
    <ng-template pTemplate="footer">
      <button type="button" pButton icon="pi pi-check" label="Yes" (click)="ReApproveconfirm.accept()"></button>
      <button type="button" pButton icon="pi pi-times" label="No" (click)="ReApproveconfirm.reject()"></button>
  </ng-template>
  </p-confirmDialog>

  <p-dialog id="updateCOI" [showHeader]="false" [(visible)]="reApproveCOIChangeRequestDetailsDialog" [modal]="true" style="height:10px!important;"
[style]="{height:'auto'}" [draggable]="true" [resizable]="false" [closable]="false">
  <div class="p-dialog-header">
      <span class="p-dialog-title">COI Change Request Details</span>
      <div class="p-dialog-header-icons">
        <button type="button" class="p-dialog-header-icon p-dialog-header-maximize p-link"
          (click)="reApproveCOIChangeRequestDetailsDialog=false;closeCOIRequestDialog()"><span
            class="p-dialog-header-close-icon pi pi-times"></span></button>
      </div>
    </div>

  <div style="padding: 0px 20px 20px 20px;">
      
    <form [formGroup]="companyCOIDetailsUpdateForm">
      <div  class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label> General Liability Eff Date <span class="required-field">*</span></label>
            <p-calendar #generalLiablityEffDate  [showIcon]="true" type="date" formControlName="glEffDate"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>General Liability Exp Date<span class="required-field">*</span></label>
            <p-calendar #generalLiablityExpDate  [showIcon]="true" type="date" formControlName="glExpDate"   [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label> Automobile Liability Eff Date<span class="required-field">*</span> </label>
            <p-calendar  #automobileLiabilityEffDate  [showIcon]="true" type="date" formControlName="alEffDate"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>Automobile Liability Exp Date<span class="required-field">*</span></label>
            <p-calendar #automobileLiablityExpDate  id="calendar-id" [showIcon]="true" type="date" formControlName="alExpDate"   [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
        </div>
        <div  class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label> Umbrella Liability Eff Date<span class="required-field">*</span></label>
            <p-calendar  #umbrellaLiablityEffDate [showIcon]="true" type="date" formControlName="ulEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>Umbrella Liability Exp Date<span class="required-field">*</span></label>
            <p-calendar #umbrellaLiabilityExpDate [showIcon]="true" type="date" formControlName="ulExpDate"   [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label> Workers Compensation Eff Date<span class="required-field">*</span></label>
            <p-calendar #workersCompensationEffDate [showIcon]="true" type="date"  formControlName="wcEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>Workers Compensation Exp Date<span class="required-field">*</span></label>
            <p-calendar  #workersCompensationExpDate  [showIcon]="true" id="calendar-id"  type="date" formControlName="wcExpDate"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label> Professional Liabilty Eff Date<span class="required-field">*</span></label>
            <p-calendar #professtionalLiabilityEffDate  [showIcon]="true" type="date"  formControlName="plEffDate"[monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label>Professional Liabilty Exp Date<span class="required-field">*</span></label>
            <p-calendar #PrefessionalLiabilityExpDate [showIcon]="true" type="date"   formControlName="plExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2099" inputId="navigators">
            </p-calendar>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <div class="p-d-flex p-jc-between">
              <div class="p-text-bold">COI</div> 
              <div>
                  <button  *ngIf="showCOIFormFilePreviewEnableOnRequest" pButton pRipple type="button" [style]="{width:'70px',height:'30px'}" (click)="ShowInsuranceUploadedFileOnRequest()" label="View"  class="p-button-sm p-button-raised" style="margin-top: -3px;"></button>                                                
              </div>
          </div>       
            
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
             <label>Comments</label>
              <textarea formControlName="comments" maxlength="1000" pInputTextarea
              class="form-control" disabled></textarea>
          </div>
        </div>
        <br><br>
      </form>
       <br><br>
           <div class="text-right" style="margin-top:-40px;">
            <!-- <p-button icon="pi pi-times" label="Reject"
            (onClick)="reApproveCOIChangeRequestDetailsDialog=true;rejectionNotesDilaog=true;"
            [style]="{height:'30px','margin-right':'10px'}"  styleClass=" p-button-danger p-button-text"></p-button> -->
               <p-button icon="pi pi-check" label="Re-Approve" [disabled]="!this.companyCOIDetailsUpdateForm.valid"
                   (onClick)="reApproveCompanyCOIDetails(companyCOIDetailsUpdateForm)" [style]="{height:'30px'}" styleClass="p-button-text p-button-success p-mr-2"
                   [style]="{height:'30px'}"></p-button>
           </div>
           <br><br>
     </div>
</p-dialog>
<p-dialog header="{{documentName}} Re-Approval - {{vendorName}}" [(visible)]="documnetReApproveDetailsDialog" [modal]="true" [style]="{width: '50vw'}"
                    [draggable]="false" [resizable]="false"  [closable]="true">
                    
                    <div class=" p-mt-2 p-mb-2">
                    </div>
                    <div class="col-md-12">
                      <div class="card">
                        <div class="card-header">
                    <label>{{documentName}}</label>
                    <!-- <button pButton pRipple type="button" icon="pi pi-eye"  (click)="ShowInsuranceUploadedFileOnRequest()" [disabled]="!showCOIFormFilePreviewEnableOnRequest"
                      class="p-button-raised" style="float: right;border-radius: 50%;height: 30px;"></button> -->
                    </div>
                    <div class="card-body" style="height: 70px; display: flex; justify-content: center; align-items: center;">
                      <button pButton pRipple type="button" label="Preview" (click)="ShowInsuranceUploadedFileOnRequest()" [disabled]="!showCOIFormFilePreviewEnableOnRequest"
                      class="p-button-raised" [style]="{width:'100px',height:'30px'}"></button>
                      </div>
                      <div class="card-footer"></div>
                </div>
                    </div>
                    <br><br>
                    <div class="text-right" style="margin-top:-40px;">
                      <!-- <p-button icon="pi pi-times" label="Reject"
                      (onClick)="documnetReApproveDetailsDialog=true;rejectionNotesDilaog=true;"
                      [style]="{height:'30px','margin-right':'10px'}"  styleClass=" p-button-danger p-button-text"></p-button> -->
                         <p-button icon="pi pi-check" label="Re-Approve" 
                             (onClick)="reApproveCompanyDocumentDetails(companyCOIDetailsUpdateForm)" [style]="{height:'30px'}" styleClass="p-button-text p-button-success p-mr-2"
                             [style]="{height:'30px'}"></p-button>
                             <!-- <p-button icon="pi pi-check" label="Re-Approve" *ngIf="isApproveComments"
                             (onClick)="documnetReApproveDetailsDialog=true;approveNotesDilaog=true;" [style]="{height:'30px'}" styleClass="p-button-text p-button-success p-mr-2"
                             [style]="{height:'30px'}"></p-button> -->
                     </div>
                     
  </p-dialog>
  <p-dialog header="NCA Confirmation- {{applicantName}} - {{vendorName}}" [(visible)]="approveNCANotesDilaog" [modal]="true" [draggable]="false"
    [resizable]="false" [closable]="false" style="width: 60% !important;">
    <div class="p-field p-col-12 p-md-1">
    </div>
    <div class="card p-m-2 p-p-2">
      <span class="p-text-bold p-text-center">
        The NCA has been approved successfully and the onboarding status of the corresponding vendor has been updated to Vendor Onboarded
      </span>
    </div>
    <div class="p-d-flex p-jc-end p-ai-right p-mt-2">
      <!-- <p-button icon="pi pi-times" [ngStyle]="{'height.px': 30 }" styleClass=" p-button-danger p-mr-2"
        (onClick)="cancelApproval()" pRipple type="button" label="close"
        class="p-button-sm p-button-info p-ai-center"></p-button>&nbsp;&nbsp;&nbsp; -->
        <p-button icon="pi pi-check" style="height: 30px !important;" (click)="cancelApproval();" label="Ok" styleClass="p-button-sm p-button-primary">
        </p-button>
    </div>
  </p-dialog>